// extracted by mini-css-extract-plugin
export var section = "LeadScore-module--section--Okm4w";
export var decoration = "LeadScore-module--decoration--qXbZ2";
export var wrapper = "LeadScore-module--wrapper--1X3uY";
export var leadCard = "LeadScore-module--lead-card--3zuEs";
export var firstColumn = "LeadScore-module--first-column--Sb8Zg";
export var leadScore = "LeadScore-module--lead-score--3gv-E";
export var leadBasicInfo = "LeadScore-module--lead-basic-info--15930";
export var leadImage = "LeadScore-module--lead-image--3HGSF";
export var companyName = "LeadScore-module--company-name--3TzcX";
export var companyInfoWrapper = "LeadScore-module--company-info-wrapper--3E1Sy";
export var leadText = "LeadScore-module--lead-text--3Ag3V";